/* Oppie footer marquee — rAF-driven translate with scroll-boosted velocity.
   Baseline runs slow (BASE_PX_PER_SEC). Scroll deltas raise the multiplier
   which then decays back to 1. Pauses when offscreen. */

(function () {
  const marquee = document.querySelector('.oppie-footer__marquee');
  if (!marquee) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;

  const track = marquee.querySelector('.oppie-footer__marquee-track');
  if (!track) return;

  // Take over from the CSS @keyframes so we can vary speed mid-flight.
  track.style.animation = 'none';
  track.style.willChange = 'transform';

  const BASE_PX_PER_SEC = 28;     // slow, calm baseline
  const MAX_MULTIPLIER = 7;
  const DECAY_PER_FRAME = 0.94;   // ~60fps → ~600ms to return to ~1
  const SCROLL_BOOST_DIVISOR = 4; // higher = less sensitive to scroll
  const MAX_DT = 0.05;            // s — clamp big tab-resume jumps

  let trackHalfWidth = 0;
  let position = 0;
  let multiplier = 1;
  let lastTime = 0;
  let lastScrollY = window.scrollY;
  let running = false;
  let rafId = null;

  function measure() {
    // The track contains 2 identical rows; halfWidth = one row's width.
    trackHalfWidth = track.scrollWidth / 2;
  }

  function frame(now) {
    rafId = null;
    if (!running) return;

    const dt = Math.min((now - lastTime) / 1000, MAX_DT);
    lastTime = now;

    multiplier = 1 + (multiplier - 1) * DECAY_PER_FRAME;
    if (multiplier < 1.001) multiplier = 1;

    if (trackHalfWidth > 0) {
      position -= BASE_PX_PER_SEC * multiplier * dt;
      // Wrap so the second copy seamlessly takes over.
      if (position <= -trackHalfWidth) {
        position += trackHalfWidth;
      }
      track.style.transform = `translate3d(${position.toFixed(2)}px, 0, 0)`;
    }

    rafId = requestAnimationFrame(frame);
  }

  function start() {
    if (running) return;
    running = true;
    lastTime = performance.now();
    rafId = requestAnimationFrame(frame);
  }

  function stop() {
    running = false;
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function onScroll() {
    const dy = Math.abs(window.scrollY - lastScrollY);
    lastScrollY = window.scrollY;
    if (dy === 0) return;
    const boost = 1 + dy / SCROLL_BOOST_DIVISOR;
    if (boost > multiplier) {
      multiplier = Math.min(boost, MAX_MULTIPLIER);
    }
  }

  // Pause while the footer is offscreen — saves CPU on long pages.
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) start(); else stop();
      }
    },
    { rootMargin: '200px 0px' }
  );

  // Measure once at load, once when fonts ready (text width changes), once on resize.
  measure();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measure);
  }
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });

  io.observe(marquee);

  reduce.addEventListener('change', (e) => {
    if (e.matches) {
      stop();
      track.style.transform = 'translate3d(0, 0, 0)';
    } else {
      measure();
      start();
    }
  });
})();

/* Oppie footer nieuwsbrief: plain form + fetch naar /contact, zodat de pagina
   niet herlaadt (een {% form %} haakt hCaptcha aan die native submit() doet). */
(function () {
  const form = document.querySelector('[data-oppie-signup]');
  if (!form) return;

  const wrapper = form.closest('.oppie-footer__signup');
  const success = wrapper && wrapper.querySelector('[data-oppie-signup-success]');
  const error = form.querySelector('[data-oppie-signup-error]');
  const note = form.querySelector('[data-oppie-signup-note]');
  const submit = form.querySelector('button[type="submit"]');

  // Vangnet: als iets toch native submit() aanroept, niet navigeren.
  form.submit = () => {};

  const showError = () => {
    if (note) note.hidden = true;
    if (error) error.hidden = false;
  };

  const showSuccess = () => {
    form.hidden = true;
    if (success) success.hidden = false;
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    if (error) error.hidden = true;
    if (note) note.hidden = false;
    if (submit) submit.setAttribute('aria-busy', 'true');
    try {
      const response = await window.fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      if (response.status >= 500) {
        showError();
        return;
      }
      showSuccess();
    } catch (err) {
      showError();
    } finally {
      if (submit) submit.removeAttribute('aria-busy');
    }
  });
})();
